/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copied_To_ClipboardInputs */

const en_copied_to_clipboard = /** @type {(inputs: Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied to clipboard`)
};

const es_copied_to_clipboard = /** @type {(inputs: Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado al portapapeles`)
};

const fr_copied_to_clipboard = /** @type {(inputs: Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copié dans le presse-papiers`)
};

const de_copied_to_clipboard = /** @type {(inputs: Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In die Zwischenablage kopiert`)
};

const ja_copied_to_clipboard = /** @type {(inputs: Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリップボードにコピーしました`)
};

const zh_copied_to_clipboard = /** @type {(inputs: Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已复制到剪贴板`)
};

const ar_copied_to_clipboard = /** @type {(inputs: Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم النسخ إلى الحافظة`)
};

const id_copied_to_clipboard = /** @type {(inputs: Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disalin ke papan klip`)
};

const it_copied_to_clipboard = /** @type {(inputs: Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiato negli appunti`)
};

const ru_copied_to_clipboard = /** @type {(inputs: Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировано в буфер обмена`)
};

const pt_copied_to_clipboard = /** @type {(inputs: Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado para a área de transferência`)
};

const ko_copied_to_clipboard = /** @type {(inputs: Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`클립보드에 복사됨`)
};

/**
* | output |
* | --- |
* | "Copied to clipboard" |
*
* @param {Copied_To_ClipboardInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const copied_to_clipboard = /** @type {((inputs?: Copied_To_ClipboardInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copied_To_ClipboardInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_copied_to_clipboard(inputs)
	if (locale === "es") return es_copied_to_clipboard(inputs)
	if (locale === "fr") return fr_copied_to_clipboard(inputs)
	if (locale === "de") return de_copied_to_clipboard(inputs)
	if (locale === "ja") return ja_copied_to_clipboard(inputs)
	if (locale === "zh") return zh_copied_to_clipboard(inputs)
	if (locale === "ar") return ar_copied_to_clipboard(inputs)
	if (locale === "id") return id_copied_to_clipboard(inputs)
	if (locale === "it") return it_copied_to_clipboard(inputs)
	if (locale === "ru") return ru_copied_to_clipboard(inputs)
	if (locale === "pt") return pt_copied_to_clipboard(inputs)
	return ko_copied_to_clipboard(inputs)
});